import React from 'react'
import PropTypes from 'prop-types'
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap'
import pluralize from 'pluralize'

class StudentFilter extends React.Component {
  handleChange = e => {
    this.props.handleChange(e.target.value)
  }

  render() {
    const studentsString = `Displaying ${this.props.numFilteredStudents} ${
      this.props.value === 'atrisk' ? 'at-risk' : this.props.value
    } ${pluralize('student', this.props.numFilteredStudents)} out of ${
      this.props.numStudents
    } total students`
    const popover = (
      <Popover id="student_filter_popover" title="Student Filters">
        <p>
          {' '}
          <strong> At-Risk Students</strong>: Below 60% average assessment
          score. <sup>*</sup>{' '}
        </p>
        <p>
          {' '}
          <strong> Average Students</strong>: Between 60% and 80% average
          assessment score. <sup>*</sup>{' '}
        </p>
        <p>
          {' '}
          <strong> Excellent Students</strong>: Above 80% average assessment
          score. <sup>*</sup>{' '}
        </p>
        <p>
          {' '}
          <i>
            * This includes assessments the student has submitted and/or
            assessments in which the due date has passed.{' '}
          </i>
        </p>
      </Popover>
    )

    return (
      <div className="filter_container">
        <div className="flex">
          <ButtonToolbar>
            <ButtonGroup className="nav nav-pills" name="student_filter">
              <Button
                active={this.props.value === ''}
                onClick={this.handleChange}
                value=""
              >
                All Students
              </Button>
              <Button
                active={this.props.value === 'atrisk'}
                onClick={this.handleChange}
                value="atrisk"
              >
                At-Risk
              </Button>
              <Button
                active={this.props.value === 'average'}
                onClick={this.handleChange}
                value="average"
              >
                Average
              </Button>
              <Button
                active={this.props.value === 'excellent'}
                onClick={this.handleChange}
                value="excellent"
              >
                Excellent
              </Button>
            </ButtonGroup>
          </ButtonToolbar>
          <div style={{ verticalAlign: 'middle' }}>
            <OverlayTrigger
              trigger={['hover', 'focus']}
              placement="left"
              overlay={popover}
            >
              <span className="fas fa-info-circle ml-4 mt-3 mr-3 text-primary" />
            </OverlayTrigger>
          </div>
        </div>
        <div className="num_students_container">{studentsString}</div>
      </div>
    )
  }
}

StudentFilter.propTypes = {
  numFilteredStudents: PropTypes.number,
  numStudents: PropTypes.number,
  handleChange: PropTypes.func,
  value: PropTypes.string,
}

export default StudentFilter
